<!-- <div class="d-flex flex-column flex-root h-100">
  <div class="interval-auth login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white" id="kt_login">
    <router-outlet></router-outlet>
  </div>
</div> -->

<router-outlet></router-outlet>